import { Avatar, Badge } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const StyledBadge = styled(Badge)(({ theme, badgecolor }) => ({
  '& .MuiBadge-badge': {
    backgroundColor: badgecolor || '#f44336',
    color: badgecolor || '#f44336',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const handleInitials = (firstName, lastName) =>
  [firstName?.charAt(0), lastName?.charAt(0)].filter(Boolean).join('');

const UserAvatar = ({
  photo,
  firstName,
  lastName,
  showBadge = false,
  badgeColor,
  badgePosition = { vertical: 'bottom', horizontal: 'right' },
}) => {
  const avatar = (
    <Avatar alt={[firstName, lastName].filter(Boolean).join(' ')} src={photo}>
      {handleInitials(firstName, lastName)}
    </Avatar>
  );

  if (!showBadge) return avatar;

  return (
    <StyledBadge
      overlap="circular"
      variant="dot"
      anchorOrigin={badgePosition}
      badgecolor={badgeColor}
    >
      {avatar}
    </StyledBadge>
  );
};

UserAvatar.propTypes = {
  photo: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  showBadge: PropTypes.bool,
  badgeColor: PropTypes.string,
  badgePosition: PropTypes.shape({
    vertical: PropTypes.oneOf(['top', 'bottom']),
    horizontal: PropTypes.oneOf(['left', 'right']),
  }),
};

export default UserAvatar;
